import { Tooltip, TooltipContent, TooltipTrigger } from "@myela/ui";
import type { ReactNode } from "react";

/**
 * Standard tooltip for icon-only buttons. Wraps a single focusable element in the
 * shared @myela/ui dark tooltip (the same bubble the collapsed sidebar uses), so
 * icon-only actions read consistently across the app. Keep an `aria-label` on the
 * child for accessibility.
 */
export function IconTooltip({
  label,
  side = "top",
  className,
  children,
}: {
  label: ReactNode;
  side?: "top" | "right" | "bottom" | "left";
  /** Extra classes for the tooltip bubble — e.g. a higher `z-*` to sit above a floating panel. */
  className?: string;
  /** A single focusable element (the button) — receives the trigger props/ref. */
  children: ReactNode;
}) {
  if (!label) return <>{children}</>;

  return (
    <Tooltip>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent side={side} className={className}>
        {label}
      </TooltipContent>
    </Tooltip>
  );
}
